import React from 'react';
import { Link } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { signOut } from '../lib/supabase';

interface NavbarProps {
  session: any;
}

const Navbar: React.FC<NavbarProps> = ({ session }) => {
  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <nav className="bg-dark-overlay/80 backdrop-blur-md border-b border-white/5 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center group">
              <img
                src="/logo-ati-horizontal.svg"
                alt="Asistente Trading IA"
                className="h-10"
              />
            </Link>
          </div>
          <div className="flex items-center space-x-3 sm:space-x-6">
            {session ? (
              <>
                <Link to="/dashboard" className="nav-link">
                  Dashboard
                </Link>
                <button
                  onClick={handleSignOut}
                  className="flex items-center nav-link"
                >
                  <LogOut className="h-4 w-4 mr-2" />
                  Cerrar Sesión
                </button>
              </>
            ) : (
              <>
                <Link to="/embajadores" className="text-xs text-gray-400 hover:text-primary transition-colors">
                  <span className="sm:hidden">¿Embajador?</span>
                  <span className="hidden sm:inline">¿Quieres ser embajador?</span>
                </Link>
                <Link to="/login" className="nav-link text-xs sm:text-sm">
                  <span className="sm:hidden">Login</span>
                  <span className="hidden sm:inline">Iniciar Sesión</span>
                </Link>
                <Link to="/register" className="btn-primary text-xs sm:text-sm px-3 py-1.5 sm:px-4 sm:py-2">
                  <span className="sm:hidden">Registro</span>
                  <span className="hidden sm:inline">Registrarse</span>
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;